export function isNotEmpty(url?: string): boolean {
    return Boolean(url && url !== '');
}
